import React, { useState } from 'react';
import { ListView } from '@progress/kendo-react-listview';
import { Pager } from '@progress/kendo-react-data-tools';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';



const useStyles = makeStyles((theme) => ({
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1.5),
    },
    // Default root styles
    color: 'inherit',
    chipColour: 'lightgray',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,

    '&:hover': {
      color:'white',
      // Set hover color
      backgroundColor: 'lightblue',
      chipColour: 'blue'
    },
  },

  hover: {},
}));

export const StreetListView = ({ streets, handleSelection }) => {

  const take = 10;
  const [skip, setSkip] = useState(0);

  const handlePageChange = (e) => {
    setSkip(e.skip);
  }

  const classes = useStyles();

  const streetRender = (props) => {

    let item = props.dataItem;
    return (
      <div onClick={() => handleSelection(item.usrn)}>
      <Grid container justify="left" className={classes.root}>
        <Grid item xs={12} spacing={0}>
          <Grid container justify="left" spacing={2}>
            <Grid item xs={2} spacing={0}>
            <Typography variant="body1">
              <Chip label={item.usrn} color="chipColour" />
            </Typography>
            </Grid>            
            <Grid item justify="left" spacing={0}>
                <Typography variant="body1">
                {item.street}
                  <Typography variant="subtitle2" gutterBottom>
                  {`${item.town}, ${item.county}`}
                  </Typography>
              </Typography>
                </Grid>

          </Grid>
        </Grid>
        </Grid>
        </div>
    );
  }


  return (
    <React.Fragment>
        <ListView
      data={streets && streets.slice(skip, skip + take)}
      item={streetRender}
      style={{ width: "100%" }}
    />
      <Pager
        skip={skip}
        take={take}
        total={streets && streets.length}
        onPageChange={handlePageChange}
        buttonCount={3}
        info={true}
        previousNext={true}
        type="numeric"
        pageSizes={[10, 15, 20]}
      />
      </React.Fragment>
    );
}

